module.exports = __webpack_public_path__ + "static/anti-cheating-b8d07944a17509ee42314f67b3759cfb.svg";